import { css } from '@emotion/react';

export const styles = {
  wrapper: css`
    padding: 24px;
  `,

  header: css`
    display: flex;
    justify-content: space-between;
    align-items: center;

    h3 {
      margin: 0;
      font-size: 18px;
      font-weight: 500;
    }
  `,

  badge: css`
    background: #ede9fe;
    color: #7c3aed;
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 12px;
  `,

  location: css`
    margin: 6px 0 10px;
    font-size: 13px;
    color: #9ca3af;
  `,

  skills: css`
    display: flex;
    gap: 8px;

    span {
      padding: 4px 10px;
      border-radius: 999px;
      background: #f3f4f6;
      font-size: 12px;
    }
  `,
};
